import { Sparkles } from "lucide-react";
import type { CampaignAnswer } from "@/shared/types/featureTeasing.types";
import { Button } from "@/shared/ui/Button";

type Props = {
  disabled: boolean
  onRespond: (answer: CampaignAnswer) => void
};

export const UpsellActions = ({ disabled, onRespond }: Props) => (
  <>
    <Button variant="ghost" disabled={disabled} onClick={() => onRespond("declined")}>Non</Button>
    <Button variant="outline" disabled={disabled} onClick={() => onRespond("later")}>Plus tard</Button>
    <Button className="relative h-auto min-h-9 min-w-0 max-w-full whitespace-normal overflow-hidden border-0 bg-gradient-to-r from-indigo-500 via-purple-500 to-fuchsia-500 text-white shadow-lg shadow-purple-500/30 hover:text-white hover:brightness-110 dark:text-white" disabled={disabled} onClick={() => onRespond("interested")}>
      <span aria-hidden="true" className="animate-advent-cta-shimmer pointer-events-none absolute inset-y-0 left-0 w-1/3 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
      <Sparkles aria-hidden="true" className="size-4" />
      Je suis intéressé(e) !
    </Button>
  </>
);
